const GOOGLE_PLACES_URL = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyATgfAJ5DNnbKIDhMAeux0hoH2MAYpVxnU&libraries=places';

export const loadLibrary = (callback = () => {}) => {
  const gscript = document.createElement('script');
  gscript.src = GOOGLE_PLACES_URL;
  gscript.async = true;
  gscript.onload = callback;
  document.body.appendChild(gscript);
}